import { Libraries } from '@react-google-maps/api';

/**
 * The single Google Maps JS loader configuration for the whole app.
 *
 * @react-google-maps/api's `useJsApiLoader` delegates to a module-level Loader
 * singleton that persists for the lifetime of the page — it is NOT torn down
 * when the component that created it unmounts. Initializing it a second time
 * with a different id / key / libraries set hard-throws ("Loader must not be
 * called again with different options"), which surfaces as a blank render in
 * whichever screen happens to mount second.
 *
 * That made every duplicated copy of this config a cross-screen landmine:
 * signup's InputWithPlacesAPI and the dashboard's CityAutocomplete /
 * VendorMarketplace / vendor-location forms each declared their own, kept in
 * sync only by a comment. Adding a library to one of them would crash the
 * others later in the same session. One exported object removes the invariant
 * instead of documenting it.
 *
 * `libraries` is a module constant (never an inline array literal) for the same
 * reason the library's own docs call out: a fresh array identity on each render
 * makes the loader think the options changed and triggers a reload warning.
 */
export const GOOGLE_MAPS_API_KEY = process.env
  .REACT_APP_GOOGLE_MAPS_API_KEY as string;

const libraries: Libraries = ['places', 'maps'];

export const GOOGLE_MAPS_LOADER_OPTIONS = {
  id: 'google-map-script',
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  libraries,
} as const;
